import React from "react";
import AOS from "aos";

const AosAnimation = () => {

    React.useEffect(() => {
        AOS.init();
    }, []);

    return null;
}

export default AosAnimation;
